module.exports = __webpack_public_path__ + "img/teammanagement_2.8a34fd56.jpg";